import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class DataManagerAutoConnectIndexRoute extends Route {
	@service('navigation') declare navigationService: Service.Navigation;

	override beforeModel(): void {
		this.navigationService.replaceRoute('datamanager.available');
	}
}
